/** Web Audio motor — felhasználói interakció után aktiválódik. */
export const AudioEngine = {
  ctx: null as AudioContext | null,

  init(): void {
    if (!this.ctx) {
      try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) {
          console.warn('AudioContext nem támogatott ebben a böngészőben.');
          return;
        }
        this.ctx = new Ctx();
      } catch {
        console.warn('AudioContext nem támogatott ebben a böngészőben.');
      }
    }
    if (this.ctx && this.ctx.state === 'suspended') {
      void this.ctx.resume();
    }
  },

  playBeep(freq: number, type: OscillatorType = 'sine', duration: number): void {
    this.init();
    if (!this.ctx) return;
    try {
      const osc = this.ctx.createOscillator();
      const gain = this.ctx.createGain();
      osc.type = type;
      osc.frequency.setValueAtTime(freq, this.ctx.currentTime);
      gain.gain.setValueAtTime(0.08, this.ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.0001, this.ctx.currentTime + duration);
      osc.connect(gain);
      gain.connect(this.ctx.destination);
      osc.start();
      osc.stop(this.ctx.currentTime + duration);
    } catch {
      /* ignore */
    }
  },

  playDroneNoise(): void {
    this.init();
    if (!this.ctx) return;
    try {
      const osc1 = this.ctx.createOscillator();
      const osc2 = this.ctx.createOscillator();
      const modulator = this.ctx.createOscillator();
      const modGain = this.ctx.createGain();
      const gain = this.ctx.createGain();
      const filter = this.ctx.createBiquadFilter();

      osc1.frequency.setValueAtTime(220, this.ctx.currentTime);
      osc2.frequency.setValueAtTime(224, this.ctx.currentTime);
      osc1.type = 'sawtooth';
      osc2.type = 'triangle';

      modulator.frequency.setValueAtTime(35, this.ctx.currentTime);
      modGain.gain.setValueAtTime(12, this.ctx.currentTime);

      filter.type = 'lowpass';
      filter.frequency.setValueAtTime(900, this.ctx.currentTime);

      modulator.connect(modGain);
      modGain.connect(osc1.frequency);
      modGain.connect(osc2.frequency);

      gain.gain.setValueAtTime(0.015, this.ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.0001, this.ctx.currentTime + 0.45);

      osc1.connect(filter);
      osc2.connect(filter);
      filter.connect(gain);
      gain.connect(this.ctx.destination);

      modulator.start();
      osc1.start();
      osc2.start();

      modulator.stop(this.ctx.currentTime + 0.45);
      osc1.stop(this.ctx.currentTime + 0.45);
      osc2.stop(this.ctx.currentTime + 0.45);
    } catch {
      /* ignore */
    }
  },

  playSprayNoise(): void {
    this.init();
    if (!this.ctx) return;
    try {
      const bufferSize = this.ctx.sampleRate * 0.2;
      const buffer = this.ctx.createBuffer(1, bufferSize, this.ctx.sampleRate);
      const data = buffer.getChannelData(0);
      for (let i = 0; i < bufferSize; i++) {
        data[i] = Math.random() * 2 - 1;
      }
      const whiteNoise = this.ctx.createBufferSource();
      whiteNoise.buffer = buffer;
      const filter = this.ctx.createBiquadFilter();
      filter.type = 'bandpass';
      filter.frequency.value = 1000;
      const gain = this.ctx.createGain();
      gain.gain.setValueAtTime(0.03, this.ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.0001, this.ctx.currentTime + 0.2);
      whiteNoise.connect(filter);
      filter.connect(gain);
      gain.connect(this.ctx.destination);
      whiteNoise.start();
    } catch {
      /* ignore */
    }
  },
};

export function unlockAudioOnFirstClick(): void {
  window.addEventListener(
    'click',
    () => {
      AudioEngine.init();
    },
    { once: true },
  );
}
